import React from 'react';
import { Box, Button } from '@material-ui/core';

const HeaderFixedNav = ({ sectionConfig = {}, layoutContext = {}, globalConfig = {} }) => {
  const {
    isDesktop,
    functionMap,
    applyHoverEffect,
    removeHoverEffect,
    getIcon,
    handleLoginClick,
    getLandingPagelogo
  } = layoutContext;

  const loginButtonConfig = sectionConfig.loginButton || {};
  const loginButtonHasExplicitIcon = Object.prototype.hasOwnProperty.call(loginButtonConfig, 'icon');
  const resolvedLoginIconName = loginButtonHasExplicitIcon ? loginButtonConfig.icon : 'login';
  const loginButtonIcon =
    typeof resolvedLoginIconName === 'string' && resolvedLoginIconName.trim().length > 0
      ? getIcon?.(resolvedLoginIconName)
      : null;

  if (!sectionConfig) {
    return null;
  }

  const logoSource = sectionConfig.logoUrl || (typeof getLandingPagelogo === 'function' ? getLandingPagelogo() : '');

  return (
    <Box style={sectionConfig.styles || {}}>
      <Box style={sectionConfig.containerStyles || {}}>
        <Box style={sectionConfig.logoContainerStyles || {}}>
          {sectionConfig.logoBox ? (
            <Box style={sectionConfig.logoBox.styles || {}}>
              <Box component="span" style={sectionConfig.logoBox.textStyles || {}}>{sectionConfig.logoBox.text}</Box>
            </Box>
          ) : (
            <img
              alt=""
              src={logoSource}
              className="d-inline-block"
              style={sectionConfig.logoStyles || {}}
            />
          )}
          <Box style={{ display: 'flex', flexDirection: 'column' }}>
            <Box component={sectionConfig.typography?.component || 'span'} style={sectionConfig.titleStyles || {}}>
              {sectionConfig.title || globalConfig?.title}
            </Box>
            {sectionConfig.subtitle && (
              <Box component="span" style={sectionConfig.subtitleStyles || {}}>
                {sectionConfig.subtitle}
              </Box>
            )}
          </Box>
        </Box>

        {isDesktop && sectionConfig.navigationPosition !== 'right' && Array.isArray(sectionConfig.navigation) && sectionConfig.navigation.length > 0 && (
          <Box style={sectionConfig.navigationStyles || {}}>
            {sectionConfig.navigation.map((navItem, index) => (
              <Button
                key={`header-nav-${index}`}
                onClick={() => {
                  const action = navItem.action;
                  if (action && functionMap?.[action]) {
                    functionMap[action]();
                  }
                }}
                style={sectionConfig.navLinkStyles || {}}
                onMouseEnter={(e) => applyHoverEffect?.(e, sectionConfig.navLinkHoverStyles || {})}
                onMouseLeave={(e) => removeHoverEffect?.(e, sectionConfig.navLinkStyles || {})}
              >
                {navItem.text}
              </Button>
            ))}
          </Box>
        )}

        <Box style={sectionConfig.buttonContainerStyles || {}}>
          {isDesktop && sectionConfig.navigationPosition === 'right' && Array.isArray(sectionConfig.navigation) && sectionConfig.navigation.map((navItem, index) => (
            <Button
              key={`header-nav-right-${index}`}
              onClick={() => {
                const action = navItem.action;
                if (action && functionMap?.[action]) {
                  functionMap[action]();
                }
              }}
              style={sectionConfig.navLinkStyles || {}}
              onMouseEnter={(e) => applyHoverEffect?.(e, sectionConfig.navLinkHoverStyles || {})}
              onMouseLeave={(e) => removeHoverEffect?.(e, sectionConfig.navLinkStyles || {})}
            >
              {navItem.text}
            </Button>
          ))}
          <Button
            variant={sectionConfig.loginButton?.variant || 'contained'}
            startIcon={loginButtonIcon}
            onClick={() => {
              const action = sectionConfig.loginButton?.action;
              if (action && functionMap?.[action]) {
                functionMap[action]();
              } else {
                handleLoginClick?.();
              }
            }}
            style={sectionConfig.loginButton?.styles || {}}
            onMouseEnter={(e) => applyHoverEffect?.(e, sectionConfig.loginButton?.hoverStyles || {})}
            onMouseLeave={(e) => removeHoverEffect?.(e, sectionConfig.loginButton?.styles || {})}
          >
            {sectionConfig.loginButton?.text || 'Login'}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default HeaderFixedNav;
